// Mock data for ALM Group of Companies

export const companyInfo = {
  name: "ALM Group of Companies",
  tagline: "Excellence in Trading, Consulting & Technology",
  email: "info@almgroupofcompanies.com",
  phone: "+1 (555) 123-4567",
  address: "650 California St, San Francisco, CA 94108",
  businessHours: "Monday - Friday: 9:00 AM - 6:00 PM PST",
  socialMedia: {
    linkedin: "#",
    twitter: "#",
    facebook: "#"
  }
};

export const divisions = [
  {
    id: "trading",
    name: "ALM Trading LLC",
    shortName: "Trading Division",
    tagline: "Global Trade Solutions",
    description: "Leading provider of international trade services, specializing in import/export operations across multiple industries. We facilitate seamless global commerce with expertise in logistics, customs, and supply chain management.",
    image: "https://images.unsplash.com/photo-1605745341112-85968b19335b",
    services: [
      {
        name: "Import & Export Services",
        description: "Comprehensive solutions for moving goods across international borders with full regulatory compliance."
      },
      {
        name: "Supply Chain Management",
        description: "End-to-end optimization of your supply chain for maximum efficiency and cost savings."
      },
      {
        name: "Customs Clearance",
        description: "Expert handling of customs documentation and clearance procedures worldwide."
      },
      {
        name: "Logistics Coordination",
        description: "Seamless coordination of shipping, warehousing, and distribution operations."
      },
      {
        name: "Trade Compliance",
        description: "Ensure full compliance with international trade regulations and standards."
      },
      {
        name: "International Shipping",
        description: "Reliable shipping solutions via air, sea, and land transportation networks."
      }
    ],
    industries: [
      "Manufacturing",
      "Agriculture",
      "Technology",
      "Consumer Goods",
      "Industrial Equipment",
      "Pharmaceuticals"
    ]
  },
  {
    id: "consultancy",
    name: "ALM Consultants LLC",
    shortName: "Consultancy Division",
    tagline: "Strategic Business Solutions",
    description: "Expert business and management consulting services designed to drive growth, optimize operations, and achieve strategic objectives. Our consultants bring decades of experience across various industries.",
    image: "https://images.unsplash.com/photo-1606836591695-4d58a73eba1e",
    services: [
      {
        name: "Business Strategy",
        description: "Develop comprehensive strategies to achieve your long-term business objectives and competitive advantage."
      },
      {
        name: "Financial Planning & Analysis",
        description: "Data-driven financial insights and planning to optimize profitability and cash flow."
      },
      {
        name: "Operations Optimization",
        description: "Streamline processes and improve operational efficiency to reduce costs and boost productivity."
      },
      {
        name: "Regulatory Compliance",
        description: "Navigate complex regulatory landscapes with expert guidance and compliance strategies."
      },
      {
        name: "Risk Management",
        description: "Identify, assess, and mitigate business risks to protect your organization's assets."
      },
      {
        name: "Market Research & Analysis",
        description: "In-depth market intelligence to inform strategic decisions and identify growth opportunities."
      }
    ],
    industries: [
      "Financial Services",
      "Healthcare",
      "Retail",
      "Manufacturing",
      "Technology",
      "Real Estate"
    ]
  },
  {
    id: "it-services",
    name: "ALM IT Services",
    shortName: "IT Services Division",
    tagline: "Infrastructure & Support Excellence",
    description: "Comprehensive IT infrastructure and support services to keep your business running smoothly. From network setup to ongoing maintenance, we ensure your technology infrastructure is robust and reliable.",
    image: "https://images.unsplash.com/photo-1580106815433-a5b1d1d53d85",
    services: [
      {
        name: "IT Infrastructure Setup",
        description: "Design and implement robust IT infrastructure tailored to your business requirements."
      },
      {
        name: "Network Management",
        description: "Comprehensive network design, implementation, and ongoing management services."
      },
      {
        name: "Cybersecurity Solutions",
        description: "Protect your business with advanced security measures and threat prevention strategies."
      },
      {
        name: "Cloud Migration",
        description: "Seamless transition to cloud platforms with minimal disruption to operations."
      },
      {
        name: "24/7 Technical Support",
        description: "Round-the-clock support to ensure your systems remain operational at all times."
      },
      {
        name: "System Maintenance",
        description: "Proactive maintenance and updates to keep your IT systems running optimally."
      }
    ],
    technologies: [
      "Cloud Platforms (AWS, Azure, Google Cloud)",
      "Network Security Tools",
      "Virtualization Technologies",
      "Backup & Disaster Recovery",
      "Monitoring & Analytics"
    ]
  },
  {
    id: "software",
    name: "ALM Software Services",
    shortName: "Software Division",
    tagline: "Custom Software Development",
    description: "Innovative software solutions tailored to your business needs. We build scalable, secure, and user-friendly applications that drive digital transformation and business growth.",
    image: "https://images.unsplash.com/photo-1576936422505-18d321d54d40",
    services: [
      {
        name: "Custom Software Development",
        description: "Bespoke software solutions designed to meet your unique business requirements and workflows."
      },
      {
        name: "Web Application Development",
        description: "Modern, responsive web applications built with latest frameworks and best practices."
      },
      {
        name: "Mobile App Development",
        description: "Native and cross-platform mobile apps for iOS and Android devices."
      },
      {
        name: "API Integration",
        description: "Seamless integration with third-party services and internal systems via robust APIs."
      },
      {
        name: "Software Consulting",
        description: "Expert guidance on technology selection, architecture design, and best practices."
      },
      {
        name: "Maintenance & Support",
        description: "Ongoing support, updates, and enhancements to keep your software running smoothly."
      }
    ],
    technologies: [
      "React, Angular, Vue.js",
      "Node.js, Python, Java",
      "iOS & Android Development",
      "Cloud-Native Architecture",
      "AI/ML Integration"
    ]
  }
];

export const pricingPlans = {
  trading: [
    {
      name: "Basic Trade Support",
      price: "$2,500",
      period: "per shipment",
      features: [
        "Single shipment coordination",
        "Basic customs clearance",
        "Standard documentation",
        "Email support",
        "Tracking updates"
      ]
    },
    {
      name: "Professional Trade Services",
      price: "$15,000",
      period: "per month",
      features: [
        "Multiple shipments",
        "Priority customs clearance",
        "Complete documentation",
        "Dedicated account manager",
        "24/7 support",
        "Supply chain optimization"
      ],
      popular: true
    },
    {
      name: "Enterprise Solutions",
      price: "Custom",
      period: "contact us",
      features: [
        "Unlimited shipments",
        "Full logistics management",
        "Compliance consulting",
        "Strategic partnership",
        "Volume discounts",
        "Custom solutions"
      ]
    }
  ],
  consultancy: [
    {
      name: "Consultation Package",
      price: "$5,000",
      period: "one-time",
      features: [
        "Initial business assessment",
        "Strategic recommendations",
        "Implementation roadmap",
        "2 follow-up sessions",
        "Written report"
      ]
    },
    {
      name: "Monthly Retainer",
      price: "$10,000",
      period: "per month",
      features: [
        "20 hours of consulting",
        "Strategic planning",
        "Performance monitoring",
        "Monthly reports",
        "Priority scheduling",
        "Dedicated consultant"
      ],
      popular: true
    },
    {
      name: "Enterprise Partnership",
      price: "Custom",
      period: "annual contract",
      features: [
        "Unlimited consulting hours",
        "Full strategic support",
        "C-level advisory",
        "Quarterly business reviews",
        "Custom solutions",
        "Multi-department support"
      ]
    }
  ],
  "it-services": [
    {
      name: "Basic IT Support",
      price: "$3,000",
      period: "per month",
      features: [
        "Up to 25 devices",
        "8/5 support",
        "Basic monitoring",
        "Security updates",
        "Monthly reports"
      ]
    },
    {
      name: "Professional IT Services",
      price: "$8,000",
      period: "per month",
      features: [
        "Up to 100 devices",
        "24/7 support",
        "Advanced monitoring",
        "Security management",
        "Cloud management",
        "Quarterly reviews"
      ],
      popular: true
    },
    {
      name: "Enterprise IT Solutions",
      price: "Custom",
      period: "annual contract",
      features: [
        "Unlimited devices",
        "Dedicated team",
        "Infrastructure design",
        "Full cybersecurity",
        "Disaster recovery",
        "Custom SLA"
      ]
    }
  ],
  software: [
    {
      name: "MVP Development",
      price: "$25,000",
      period: "one-time",
      features: [
        "Basic application",
        "Core features",
        "Web or mobile",
        "3 months support",
        "Documentation"
      ]
    },
    {
      name: "Full Application",
      price: "$75,000",
      period: "one-time",
      features: [
        "Complete application",
        "Advanced features",
        "Web and mobile",
        "6 months support",
        "Testing & QA",
        "Deployment"
      ],
      popular: true
    },
    {
      name: "Enterprise Solution",
      price: "Custom",
      period: "project-based",
      features: [
        "Complex systems",
        "Integration services",
        "Scalable architecture",
        "1 year support",
        "Dedicated team",
        "Ongoing maintenance"
      ]
    }
  ]
};

export const testimonials = [
  {
    name: "Sarah Johnson",
    position: "CEO, TechVentures Inc.",
    content: "ALM Group has been instrumental in our international expansion. Their trading division handled all our logistics seamlessly, saving us time and money.",
    rating: 5
  },
  {
    name: "Michael Chen",
    position: "CFO, Global Manufacturing Co.",
    content: "The consultancy services provided by ALM helped us optimize our operations and increase profitability by 30%. Highly recommended!",
    rating: 5
  },
  {
    name: "Emily Rodriguez",
    position: "CTO, DataStream Solutions",
    content: "ALM's IT and Software divisions transformed our technology infrastructure. Professional, reliable, and innovative.",
    rating: 5
  },
  {
    name: "David Thompson",
    position: "VP Operations, RetailMax Corp",
    content: "Working with ALM Consultants was a game-changer for our business. Their strategic insights helped us streamline operations and reduce costs by 25%. The team is knowledgeable, responsive, and truly invested in our success.",
    rating: 5
  },
  {
    name: "Jennifer Martinez",
    position: "Director of IT, HealthFirst Medical",
    content: "ALM IT Services provided exceptional support during our cloud migration. Their 24/7 monitoring and proactive maintenance have given us peace of mind. Zero downtime in the past 6 months!",
    rating: 5
  },
  {
    name: "Robert Williams",
    position: "Founder, InnovateTech Solutions",
    content: "The custom software developed by ALM exceeded our expectations. They delivered a scalable, user-friendly platform on time and within budget. Their agile approach made the entire process smooth and collaborative.",
    rating: 5
  },
  {
    name: "Lisa Anderson",
    position: "Import Manager, Global Imports LLC",
    content: "ALM Trading made our international shipping incredibly efficient. Their expertise in customs clearance and compliance saved us from costly delays. Best logistics partner we've ever worked with!",
    rating: 5
  },
  {
    name: "James Park",
    position: "COO, FinanceHub Partners",
    content: "The financial analysis and strategic planning provided by ALM Consultants helped us identify new revenue streams. Their team brought fresh perspectives and actionable recommendations that drove real growth.",
    rating: 5
  }
];

export const stats = [
  { value: "500+", label: "Successful Projects" },
  { value: "250+", label: "Global Clients" },
  { value: "15+", label: "Years Experience" },
  { value: "50+", label: "Countries Served" }
];

export const leadershipTeam = [
  {
    name: "James Anderson",
    position: "Chief Executive Officer",
    bio: "With over 20 years of experience in international business, James leads ALM Group with a vision for excellence and sustainable growth.",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a"
  },
  {
    name: "Patricia Williams",
    position: "Chief Operating Officer",
    bio: "Patricia oversees all operational aspects across our divisions, ensuring seamless service delivery and client satisfaction.",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2"
  },
  {
    name: "Robert Martinez",
    position: "Chief Technology Officer",
    bio: "Robert drives our technology strategy and innovation initiatives, keeping ALM Group at the forefront of digital transformation.",
    image: "https://images.unsplash.com/photo-1543132220-7bc04a0e790a"
  }
];
